import { StablecoinWorkflowCreate } from '../../models/workflow.model';
import { StablecoinApprovalDecisionValue } from '../../models/transfer.model';

export class InitStablecoinWorkflowsState {
	static readonly type: string = '[StablecoinWorkflows] InitStablecoinWorkflowsState';
}

export class ClearStablecoinWorkflowsState {
	static readonly type: string = '[StablecoinWorkflows] ClearStablecoinWorkflowsState';
}

export class ResetStablecoinWorkflowsState {
	static readonly type: string = '[StablecoinWorkflows] ResetStablecoinWorkflowsState';
}

export class LoadStablecoinWorkflows {
	static readonly type: string = '[StablecoinWorkflows] LoadStablecoinWorkflows';
}

export class CreateStablecoinWorkflow {
	static readonly type: string = '[StablecoinWorkflows] CreateStablecoinWorkflow';
	constructor(public body: StablecoinWorkflowCreate) {}
}

export class UpdateStablecoinWorkflow {
	static readonly type: string = '[StablecoinWorkflows] UpdateStablecoinWorkflow';
	constructor(
		public workflowId: string,
		public body: StablecoinWorkflowCreate
	) {}
}

export class DecideStablecoinWorkflow {
	static readonly type: string = '[StablecoinWorkflows] DecideStablecoinWorkflow';
	constructor(
		public workflowId: string,
		public decision: StablecoinApprovalDecisionValue,
		public comment?: string
	) {}
}

export class ArchiveStablecoinWorkflow {
	static readonly type: string = '[StablecoinWorkflows] ArchiveStablecoinWorkflow';
	constructor(public workflowId: string) {}
}
